import { render, staticRenderFns } from "./newslettersApp.vue?vue&type=template&id=13f75b64&"
import script from "./newslettersApp.vue?vue&type=script&lang=ts&"
export * from "./newslettersApp.vue?vue&type=script&lang=ts&"
import style0 from "./newslettersApp.vue?vue&type=style&index=0&id=13f75b64&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports